import React from "react";
import { PreviousWorkWidgetContainer } from "./containers/previous-work-widget.container";

const PreviousWorkModule = () => {
  return <PreviousWorkWidgetContainer />;
};

export { PreviousWorkModule };
